<template>
    <api-product-form dialog-id="create-api-product" title="Create Api Product" :product="product">
        <slot slot="submit">
            <div class="block-content block-content-full text-right bg-light">
                <button @click="save()" type="button" class="btn btn-success">Save Changes</button>
            </div>
        </slot>
    </api-product-form>
</template>

<script>
    import EventBus from '../../bus/events';
    import ProductForm from './ProductForm';
    import jQuery from 'jquery';

    export default {
        name: "CreateApiProduct",
        components: {
            'api-product-form': ProductForm
        },
        data() {
            return {
                product: {
                    id: '',
                    name: '',
                    access: '',
                    description: '',
                    meta: {
                        icon: '',
                        color: ''
                    },
                    environment: []
                },
            }
        },
        methods: {
            save() {
                this.$store.dispatch('createApiProduct', this.product)
                    .then(() => {
                        EventBus.$on('api-product-created', (product) => {
                            jQuery('#create-api-product').modal('hide');
                            for (let item in this.product) {
                                this.product.hasOwnProperty(item) ? this.product[item] = '' : false;
                            }
                            this.$store.dispatch('getApiProducts');
                            this.$router.push('/apis');
                        });
                    })
            }
        }

    }
</script>

<style scoped>

</style>
